import React, { FC, useEffect, useState } from "react";
import useNavigate from "src/hooks/useNavigate";
import { FontAwesomeIcon } from "src/constants/fontAwesomeIcons";
import useSelector from "src/hooks/useSelector";
import { INavItem } from "..";
import ReactTooltip from "react-tooltip";

import "./NewNavigation.scss";

interface INewNavigationTabProps {
    navItem?: INavItem;
}

const NewNavigationTab: FC<INewNavigationTabProps> = ({ navItem }) => {
    //
    // -- Hooks --
    const location = useSelector((state) => state.routing.location.pathname);
    const navigate = useNavigate();

    //
    // -- States --
    const [width, setWidth] = useState(window.innerWidth);

    // Sets the width state to the users screen width
    // This is used to determine whether to show the tooltip or not
    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleOnClickEvent: React.MouseEventHandler<HTMLDivElement> = (
        event
    ) => {
        rippleEffect(event);
        navigate(navItem.url);
    };

    const rippleEffect = (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>
    ) => {
        let ripple = document.createElement("span");

        // Add ripple class to span
        ripple.classList.add("ripple");

        // Add span to the button
        event.currentTarget.appendChild(ripple);

        // Get position of X
        let x = event.clientX - event.currentTarget.offsetLeft;

        // Get position of Y
        let y = event.clientY - event.currentTarget.offsetTop;

        // Position the span element
        ripple.style.left = `${x}px`;
        ripple.style.top = `${y}px`;

        // Remove span after 0.3s
        setTimeout(() => {
            ripple.remove();
        }, 300);
    };

    const isActive = () => {
        const baseRoute = location.split("/")[1];
        return ("/" + baseRoute)
            ?.toLowerCase()
            ?.includes(navItem.url?.toLowerCase());
    };

    return (
        <div
            className={`navigation-tab-transition ${
                isActive() ? "navigation-tab-selected" : "navigation-tab"
            }`}
            onClick={handleOnClickEvent}
            data-tip
            data-for={`tooltip-${navItem.title}`}
        >
            <FontAwesomeIcon icon={navItem.icon} fixedWidth />
            {navItem.title && navItem.title !== "Search" ? (
                <span className="navigation-tab-title">{navItem.title}</span>
            ) : null}
            {width < 1601 ? (
                <ReactTooltip
                    id={`tooltip-${navItem.title}`}
                    place="bottom"
                    effect="solid"
                    style={{ position: "none", zIndex: 99999999 }}
                >
                    {navItem.title}
                </ReactTooltip>
            ) : null}
        </div>
    );
};

export default NewNavigationTab;
